export const testimonies = [
  {
    name: 'Shirley Fultz',
    img: require('../../images/testimonial/testomonial3.jpg'),
    position: 'Movie Actor',
    testimony: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.',
  },
  {
    name: 'Daniel Keystone',
    img: require('../../images/testimonial/testimonial2.jpg'),
    position: 'Web Designer',
    testimony: 'A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.',
  },
  {
    name: 'Chadwick Boseman',
    img: require('../../images/testimonial/testimonial4.jpg'),
    position: 'Movie Actor',
    testimony: 'Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean.',
  },
  {
    name: 'Diana Lipo',
    img: require('../../images/testimonial/testimonial7.png'),
    position: 'Graphics Designer',
    testimony: 'A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.',
  }
]